export const useWhatsAppButton = () => {
  const phoneNumber = '5591981179825';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return {
    phoneNumber,
    whatsappUrl,
  };
};
